module.exports = __webpack_public_path__ + "static/template_options_1_day_with_task_list-1c5e66468dbf1253ab8e7611ae73f6db.png";